<!-- <p>register-lata-mangeshkar-chhindwara works!</p> -->

<section class="breadcrumb-banner">
	<div class="container">
		<div class="row">
			<div class="col-md-12 col-lg-12">
				<div class="breadcrumb-text">
					<h1>Musical Tribute</h1>
				</div>
			</div>
		</div>
	</div>
  <div class="breadcrumb-bottom-img">
    <img
        src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png"  alt="GHRSCF"/>
</div>
</section>
<section class="section section-sm summer-camp section-banner-bg-1">
  <div class="container">
    <div class="sec-title text-center">
      <h2>Forever Lata : <span > - A Musical Tribute to Bharat Ratna Lata Mangeshkar
          Chhindwara</span></h2>
    </div>
    <div class="row">
      <div class="col-md-5">
        <div class="img-dance text-center">
          <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/lata-mangeshkar-chhindwara.webp"
            class="img-fluid">
        </div>
      </div>
      <!-- <div class="col-md-7">
                  <iframe src="https://ghrscf.com/melvin-louise-folder/registration.php" allowtransparency = "true" frameborder="0" width="100%" height="484px"></iframe>

              </div> -->
      <div class="col-md-6">
        <form [formGroup]="registerForm" (ngSubmit)="submitForm()" class="comments-form contact-form">
          <input type="hidden" formControlName="city" value="wardha" id="city" class="form-control">
          <div class="row gx-3">
            <div class="col-sm-6">
              <div class="styled-input wide form-group">
                <label>Name <span class="text-danger">*</span></label>
                <input type="text" formControlName="name" required="required" id="name" class="form-control">

                <div *ngIf="f['name'].touched && f['name'].invalid" class="alert alert-danger">
                  <div *ngIf="f['name'].errors && f['name'].errors['required']">Name is required.</div>
                  <div *ngIf="f['name'].errors && f['name'].errors['minlength']">Name should be 3 character.</div>
                </div>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="styled-input wide form-group">
                <label>E-mail <span class="text-danger">*</span></label>
                <input type="email" formControlName="email" id="email" required="required" class="form-control">
                <div *ngIf="f['email'].touched && f['email'].invalid" class="alert alert-danger">
                  <div *ngIf="f['email'].errors && f['email'].errors['required']">Email is required.</div>
                  <div *ngIf="f['email'].errors && f['email'].errors['email']">Please, enter valid email address.</div>
                </div>
              </div>
            </div>
            <div class="col-sm-6 mt-3">
              <div class="styled-input wide form-group">
                <label>Mobile Number <span class="text-danger">*</span></label>
                <input type="text" formControlName="phone" id="phone" maxlength="10" required="required"
                  class="form-control">
                <div *ngIf="f['phone'].touched && f['phone'].invalid" class="alert alert-danger">
                  <div *ngIf="f['phone'].errors && f['phone'].errors['required']">Phone No. is required.</div>
                  <div *ngIf="f['phone'].errors && f['phone'].errors['minlength']">Name should be 10 Number.</div>
                </div>
              </div>
            </div>
            <div class="col-sm-6 mt-3">
              <div class="styled-input wide form-group">
                <label>Address</label>
                <textarea rows="0" formControlName="address" id="address" class="form-control"></textarea>

              </div>
            </div>

            <div class="col-sm-6">
              <div class="styled-input wide form-group">
                <label>Additional Members If any</label>
                <input type="number" formControlName="member" id="member"
                  onkeypress="if (this.value.length > 1) return false;" class="form-control">
              </div>
            </div>
            <div class="col-md-6 mt-4">
              <div class="form-group">
                <button class="btn button--effect-1 w-50"><span>
                    Submit</span> <span class="icon-right-arrow"></span></button>
              </div>

            </div>
          </div>
        </form>

      </div>
    </div>
  </div>
</section>
